<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="50px"
          inline
          @submit.native.prevent
        >
          <el-form-item label="部门" prop="department_id">
            <el-select v-model="filter.department_id" size="small">
              <el-option
                v-for="(value, name) in DepartmentCategoryMap"
                :key="name"
                :label="value"
                v-if="
                  auth.belongsToDepartment(parseInt(name)) ||
                  (name == '1' &&
                    (auth.belongsToDepartment(2) ||
                      auth.belongsToDepartment(3)))
                "
                :value="parseInt(name)"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="分类" prop="category_id">
            <category-select
              @change="filter.category_id = $event"
              :val="filter.category_id"
              :departmentID="filter.department_id"
            ></category-select>
          </el-form-item>
          <el-form-item label="件号" prop="part_number">
            <el-input
              size="small"
              v-model="filter.part_number"
              @keyup.enter.native="requestSearch"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="分类"
            prop="category_ids"
            class="mobile-gruop-select"
          >
            <category-group-select
              @change="filter.category_ids = $event"
              :val="filter.category_ids"
            ></category-group-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" size="small" @click="requestSearch"
              >筛选</el-button
            >
            <el-button size="small" @click="requestSearch('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <!-- <div class="mt-10" style="margin-left: 70px">
          <el-button type="primary" size="small" @click="requestSearch"
            >筛选</el-button
          >
          <el-button size="small" @click="requestSearch('reset')"
            >重置</el-button
          >
        </div> -->
      </div>
    </div>

    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-if="departmentAdmin"
          v-permission="Auth.commodityCreate"
          @click="handleEdit"
          >新增商品</el-button
        >
        <file-button
          v-if="departmentAdmin"
          v-permission="Auth.commodityIE"
          style="float: right"
          obj="commodity"
          :filter="filter"
          class="mobile-hide"
          @importCallback="requestSearch('reset')"
        ></file-button>
      </div>

      <el-table
        v-if="!isMobile()"
        :data="list"
        v-loading="loading"
        stripe
        style="width: 100%"
      >
        <el-table-column align="left" label="商品封面">
          <template slot-scope="scope">
            <div class="pointer" @click.prevent="showDetail(scope.row)">
              <auth-img
                tag="el-image"
                style="width: 60px; height: 60px"
                :src="scope.row.cover || scope.row.commodity_category.cover"
                fit="cover"
              ></auth-img>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="件号/描述/替代件号"
          prop="part_number"
          min-width="200"
        >
          <template slot-scope="scope">
            <div class="pointer" @click.prevent="showDetail(scope.row)">
              <div class="text-primary">
                {{ scope.row.part_number }}
              </div>
              <div style="line-height: 1.3em; font-size: 12px">
                {{ scope.row.description }} <br />{{ scope.row.description_zh }}
              </div>
              <div class="text-danger font-12" v-if="scope.row.new_part_number">
                替代件：{{ scope.row.new_part_number }}
              </div>
              <div
                class="text-warning font-12"
                v-if="scope.row.old_part_number"
              >
                旧件号：{{ scope.row.old_part_number }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="分类"
          prop="commodity_category.name"
        ></el-table-column>
        <el-table-column align="center" label="类型（产地）" min-width="100px">
          <template slot-scope="scope">
            {{ scope.row.type == 1 ? '备件' : '服务' }}（{{
              scope.row.origin_place == 1 ? '国产' : '进口'
            }}）</template
          >
        </el-table-column>
        <el-table-column align="left" label="PH/PH描述" prop="ph">
          <template slot-scope="scope">
            {{ scope.row.ph }}
            <br />
            {{ scope.row.ph_desc }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="审批要求">
          <template slot-scope="scope">
            {{ scope.row.whether_approve == 1 ? '无' : '下单' }} /
            {{ scope.row.ec_approve == 1 ? '无' : 'EC' }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="单价"
          prop="price"
          min-width="120px"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.price.toFixed(2) }}</div>
            <template v-if="scope.row.rank_price">
              <div
                v-for="(k, v) in DealerRanks"
                v-if="
                  parseInt(v) > 0 && scope.row.rank_price[parseInt(v) - 1] > 0
                "
              >
                <el-tag class="mr-5" size="mini">{{ k.slice(0, 2) }}</el-tag
                >{{ scope.row.rank_price[parseInt(v) - 1].toFixed(2) }}
              </div>
            </template>
          </template>
        </el-table-column>
        <!-- <el-table-column
          align="left"
          label="描述"
          prop="description"
          min-width="200px"
        >
          <template slot-scope="scope"
            >{{ scope.row.description }} <br />
            {{ scope.row.description_zh }}
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <status-tag
              :type="scope.row.status == 1 ? 'success' : 'gray'"
              :name="scope.row.status == 1 ? '上架中' : '未上架'"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="200"
          v-if="departmentAdmin"
        >
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.commodityStatusManage"
              :title="`确认${scope.row.status == 1 ? '下架' : '上架'}吗？`"
              @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
            >
              <el-button
                slot="reference"
                :type="scope.row.status == 1 ? 'danger' : 'primary'"
                plain
                size="mini"
                >{{ scope.row.status == 1 ? '下架' : '上架' }}</el-button
              >
            </el-popconfirm>
            <el-button
              class="ml-10"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.commodityUpdate"
              v-if="scope.row.status == 0"
              >编辑</el-button
            >
            <br />
            <!-- <router-link
              :to="`/dashboard/shop/commodity_versions?commodity_id=${scope.row.id}`"
              class="text-primary font-12 pointer"
              tag="div"
              >详情</router-link
            > -->
            <el-link
              type="primary"
              class="font-12"
              :underline="false"
              @click="showDetail(scope.row)"
              >详情查看</el-link
            >
            <router-link
              :to="`/dashboard/shop/commodity_versions?commodity_id=${scope.row.id}`"
              class="text-primary font-12 pointer ml-10"
              >版本查看</router-link
            >
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(item, index) in list">
          <div class="flex-row-between">
            <div>
              <div class="font-14">
                <span style="font-weight: bold" class="mr-5">
                  {{ item.part_number }}</span
                >
                <el-tag
                  :type="item.status == 1 ? 'primary' : 'info'"
                  size="mini"
                  >{{ item.status == 1 ? '上架中' : '未上架' }}</el-tag
                >
              </div>
              <div class="font-12 text-danger" v-if="item.new_part_number">
                替代件号：{{ item.new_part_number }}
              </div>
              <div class="text-warning font-12" v-if="item.old_part_number">
                旧件号：{{ item.old_part_number }}
              </div>
              <div class="font-12">
                分类：{{ item.commodity_category.name }}
              </div>
              <div class="font-12">
                类型（产地）：{{ item.type == 1 ? '备件' : '服务' }}（{{
                  item.origin_place == 1 ? '国产' : '进口'
                }}）
              </div>
              <div class="font-12" v-if="item.ph">PH：{{ item.ph }}</div>
              <div class="font-12 text-danger" v-if="item.remark">
                审批要求：{{ item.whether_approve == 1 ? '无' : '下单' }} /{{
                  item.ec_approve == 1 ? '无' : 'EC'
                }}
              </div>
              <div class="font-12">
                描述：{{ item.description }} {{ item.description_zh }}
              </div>
            </div>
            <div style="text-align: right; line-height: 1">
              <div
                class="text-primary"
                style="
                  font-size: 14px;
                  display: flex;
                  flex-direction: column;
                  align-items: flex-end;
                "
              >
                ￥{{ item.price.toFixed(2) }}
                <auth-img
                  tag="el-image"
                  style="width: 60px; height: 60px"
                  :src="item.cover"
                  :preview-src-list="[item.cover]"
                  fit="cover"
                >
                  <div slot="error" class="image-slot">暂无图片</div></auth-img
                >
              </div>
            </div>
          </div>
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <item-former
      :model="model"
      :show.sync="itemFormerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></item-former>

    <CommodityDetail
      :model="showItem"
      :show.sync="detailDialog"
    ></CommodityDetail>
  </div>
</template>

<script>
import { commodityList, updateCommodityStatus } from '@/service/getData'
import CategorySelect from '@/components/select/commodity_category_select'
import CategoryGroupSelect from '@/components/select/commodity_category_group_select'
import { isMobile } from '../../../util'
import ItemFormer from './former'
import { clone } from '@/util'

import { DepartmentCategoryMap } from '@/config/global'
import store from '@/store/store'
import auth from '@/util/auth'
import { DealerRanks } from '@/config/global.js'

import CommodityDetail from './detail.vue'

export default {
  components: {
    ItemFormer,
    CategorySelect,
    CategoryGroupSelect,
    CommodityDetail,
  },
  data() {
    return {
      auth,
      DealerRanks,
      DepartmentCategoryMap,
      loading: false,
      model: {
        cover: '',
        name: '',
        part_number: '',
        new_part_number: '',
        commodity_category_id: '',
        price: 0,
        rank_price: [],
        whether_approve: 1,
        ec_approve: 1,
        origin_place: 1,
        type: 1,
        description: '',
        description_zh: '',
        content: '',
      },
      itemFormerVisible: false,
      editIndex: 0,
      isMobile,
      list: [],
      total: 0,
      departmentAdmin: false,
      currentDepartmentID: 0,
      filter: {
        size: 20,
        page: 1,
        name: '',
        part_number: '',
        category_id: '',
        department_id: store.getters.userInfo.departments[0] || 0,
        category_ids: [],
      },
      showItem: {},
      detailDialog: false,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData() {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      this.loading = true
      let params = clone(this.filter)
      params.page -= 1
      params.category_ids = params.category_ids.join('&category_ids=')
      this.departmentAdmin = this.auth.belongsToDepartment(params.department_id)
      this.currentDepartmentID = params.department_id

      let res = await commodityList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.name = ''
        this.filter.part_number = ''
        this.filter.category_ids = []
        this.filter.category_id = ''
        this.filter.department_id = store.getters.userInfo.departments[0] || 0
      }
      this.getData()
    },
    createdCallback(data) {
      this.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleEdit(index, item) {
      this.itemFormerVisible = true
      if (item) {
        this.$nextTick(() => {
          this.editIndex = index
          this.model = clone(item)
          if (!this.model.rank_price) {
            this.model.rank_price = [
              ...Array(Object.keys(DealerRanks).length - 1),
            ].map((_) => 0)
          }
        })
      } else {
        this.model = {
          cover: '',
          name: '',
          part_number: '',
          new_part_number: '',
          commodity_category_id: '',
          price: 0,
          rank_price: [...Array(Object.keys(DealerRanks).length - 1)].map(
            (_) => 0
          ),
          whether_approve: 1,
          ec_approve: 1,
          origin_place: 1,
          department_id: this.currentDepartmentID,
          type: 1,
          description: '',
          description_zh: '',
          content: '',
        }
      }
    },
    async handleSwitchStatus(index, id) {
      let res = await updateCommodityStatus(id)
      if (res.code == 0) {
        this.list[index].status = res.data.status
      }
    },

    showDetail(item) {
      this.showItem = item
      this.detailDialog = true
    },
  },
}
</script>

<style scoped>
.flex-row-between {
  align-items: flex-start;
}
</style>